import { Button } from '@insify/design-system/components';
import { useBreakpoint } from '@insify/react-hooks';
import { useTranslation } from 'react-i18next';

import { Heading2, Paragraph } from '../../../components/Typography/Typography';
import { useCountrySpecificContent } from '../../../utils/localize';
import { AuthLayout } from '../../layouts/AuthLayout';

import { bodyText, content, heading } from './ForgotEmailPage.module.css';

const ForgotEmailPage = () => {
  const { t } = useTranslation('common');
  const { landing_page_contact } = useCountrySpecificContent();

  const isMobile = !useBreakpoint('(min-width: 960px)');

  const getSupport = () => {
    window.open(landing_page_contact, '_blank');
  };

  return (
    <AuthLayout>
      <div className={content}>
        <Heading2 testId='login-link-sent-header' density='condensed' className={heading}>
          {t('login_link_forgot_mail_title')}
        </Heading2>
        <Paragraph className={bodyText} density='condensed'>
          {t('login_link_forgot_mail_body')}
        </Paragraph>
      </div>
      <Button
        style={{ width: '100%' }}
        type='button'
        kind={isMobile ? 'neutral' : 'primary'}
        trackingId='support'
        onClick={getSupport}
      >
        {t('login_link_sent_support')}
      </Button>
    </AuthLayout>
  );
};

export { ForgotEmailPage };
